<template>
    <div class="pro_container">
        <!-- 头部 -->
        <v-header2></v-header2>
        <!-- 产品标题 -->
        <product-tool title="N5" color="#ffffff"></product-tool>
        <!-- 产品图片 -->
        <img class="pro_img" src="http://wx3.sinaimg.cn/large/0067mezugy1g5gny67jinj31hc0rt0ww.jpg"/>
        <img class="pro_img_mb" src="http://wx4.sinaimg.cn/large/0067mezugy1g5r4su5alwj30ku0rsjt8.jpg"/>
        <!-- 产品颜色切换效果 -->
        <div class="pro_animation">
            <swiper :options="swiperOption" v-if="seletedColor === 1">
                <!-- slides -->
                <swiper-slide v-for="(item, index) in earphones1" :key="index">
                    <div class="pro_animation_item"><img :src="item" /></div>
                </swiper-slide>
                <!-- Optional controls -->
                <div class="swiper-button-prev" slot="button-prev"><i></i></div>
                <div class="swiper-button-next" slot="button-next"><i></i></div>
            </swiper>
            <swiper :options="swiperOption" v-else>
                <!-- slides -->
                <swiper-slide v-for="(item, index) in earphones2" :key="index">
                    <div class="pro_animation_item"><img :src="item" /></div>
                </swiper-slide>
                <!-- Optional controls -->
                <div class="swiper-button-prev" slot="button-prev"><i></i></div>
                <div class="swiper-button-next" slot="button-next"><i></i></div>
            </swiper>
            <!-- 耳机颜色 -->
            <div class="pro_colors">
                爵士黑 <i :class="{active: seletedColor == 0}" @click="switchColor(0)"></i>
                <i :class="{active: seletedColor == 1}" @click="switchColor(1)"></i> 玫瑰金
            </div>
            <!-- <img src="http://wx3.sinaimg.cn/large/0067mezugy1g5c70sfwutj30l405dmxc.jpg" /> -->
            <ul class="pro_icons">
                <li v-for="(item, index) in iconList" :key="index">
                    <img :src="item.icon" />
                    <p>{{item.title}}</p>
                </li>
            </ul>
            <img class="pro_img_mb" src="http://wx1.sinaimg.cn/large/0067mezugy1g5r7dzjwqaj30ku0a7my1.jpg"/>
        </div>
        <img class="pro_img" src="http://wx3.sinaimg.cn/large/0067mezugy1g6ntbfn3qrj31hc0rsdhm.jpg"/>
        <img class="pro_img" src="http://wx4.sinaimg.cn/large/0067mezugy1g5gny78au5j31hc0ruq6j.jpg"/>
        <img class="pro_img" src="http://wx1.sinaimg.cn/large/0067mezugy1g6ntbikmbaj31hd0rsjul.jpg"/>
        <img class="pro_img" src="http://wx3.sinaimg.cn/large/0067mezugy1g5gny8dw2aj31hc0rs77h.jpg"/>
        <img class="pro_img" src="http://wx3.sinaimg.cn/large/0067mezugy1g5gny8w4hwj31hc0ruacg.jpg"/>
        <img class="pro_img" src="http://wx4.sinaimg.cn/large/0067mezugy1g6ntble3ryj31hc0rsmzc.jpg"/>
        <img class="pro_img" src="http://wx4.sinaimg.cn/large/0067mezugy1g5gny9t1ppj31hc0ruq7g.jpg"/>
        <img class="pro_img" src="http://wx2.sinaimg.cn/large/0067mezugy1g5gnyaamj2j31hc0rtjua.jpg"/>
        <img class="pro_img" src="http://wx4.sinaimg.cn/large/0067mezugy1g5gnyatce1j31hc0rsjsx.jpg"/>
        <img class="pro_img" src="http://wx1.sinaimg.cn/large/0067mezugy1g5gnyb7ry9j31hc0rttaz.jpg"/>
        <img class="pro_img" src="http://wx3.sinaimg.cn/large/0067mezugy1g5gnybp00uj31hc0rudjl.jpg"/>
        <img class="pro_img" src="http://wx4.sinaimg.cn/large/0067mezugy1g5gnycej3vj31hc0kn3zz.jpg"/>
        <img class="pro_img_mb" src="http://wx3.sinaimg.cn/large/0067mezugy1g5r4svgdpfj30ku0rs0us.jpg"/>
        <img class="pro_img_mb" src="http://wx2.sinaimg.cn/large/0067mezugy1g5r4svxlp9j30ku0rsmzk.jpg"/>
        <img class="pro_img_mb" src="http://wx4.sinaimg.cn/large/0067mezugy1g5r4swbg4wj30ku0rs40b.jpg"/>
        <img class="pro_img_mb" src="http://wx2.sinaimg.cn/large/0067mezugy1g5r4swurq1j30ku0rs0uj.jpg"/>
        <img class="pro_img_mb" src="http://wx3.sinaimg.cn/large/0067mezugy1g5r4sxatwjj30ku0rsjsa.jpg"/>
        <img class="pro_img_mb" src="http://wx1.sinaimg.cn/large/0067mezugy1g5r4syt43bj30ku0rsab3.jpg"/>
        <img class="pro_img_mb" src="http://wx2.sinaimg.cn/large/0067mezugy1g5r4szh51bj30ku0rs40x.jpg"/>
        <img class="pro_img_mb" src="http://wx3.sinaimg.cn/large/0067mezugy1g5r7dz2ugaj30ku0rsgn7.jpg"/>
        <v-footer2></v-footer2>
    </div>
</template>

<script>
import {
        swiper,
        swiperSlide
    } from 'vue-awesome-swiper'
export default {
    components: {
        swiper,
        swiperSlide
    },
    data(){
        return {
            swiperOption: {
                // notNextTick是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
                notNextTick: true,
                // swiper configs 所有的配置同swiper官方api配置
                autoplay: 3000,
                grabCursor: true,
                setWrapperSize: true,
                autoHeight: true,
                pagination: '.swiper-pagination',
                prevButton: '.swiper-button-prev',
                nextButton: '.swiper-button-next',
                paginationClickable: true,
                loop: true,
                // mousewheelControl : true,
                observeParents: true,
                // if you need use plugins in the swiper, you can config in here like this
                // 如果自行设计了插件，那么插件的一些配置相关参数，也应该出现在这个对象中，如下debugger
                debugger: true,
            },
            seletedColor: 0,
            earphones2: ["http://wx4.sinaimg.cn/large/0067mezugy1g5gobd7nr4j30f50dd3yq.jpg", "http://wx2.sinaimg.cn/large/0067mezugy1g5gobdr8hej309a0deaaa.jpg", "http://wx3.sinaimg.cn/large/0067mezugy1g5r5av2m85j308c0bn74s.jpg"],
            earphones1: ["http://wx3.sinaimg.cn/large/0067mezugy1g5gobbsrklj30f60dejrk.jpg", "http://wx1.sinaimg.cn/large/0067mezugy1g5gobc8vo0j30980dcjrl.jpg", "http://wx1.sinaimg.cn/large/0067mezugy1g5r59pdecxj308c0cgaak.jpg"],
            iconList: [{
                icon: require("../../../assets/img/n/icon15.png"),
                title: "高通CSR8645芯片"
            },{
                icon: require("../../../assets/img/n/icon2.png"),
                title: "蓝牙5.0"
            },{
                icon: require("../../../assets/img/n/icon11.png"),
                title: "霍尔开关感应磁吸"
            },{
                icon: require("../../../assets/img/n/icon12.png"),
                title: "内置高配镍钛记忆合金"
            },{
                icon: require("../../../assets/img/n/icon13.png"),
                title: "支持APT-X无损传输"
            },{
                icon: require("../../../assets/img/n/icon6.png"),
                title: "8.5小时无忧续航"
            },{
                icon: require("../../../assets/img/n/icon7.png"),
                title: "人体工学设计"
            },{
                icon: require("../../../assets/img/n/icon8.png"),
                title: "自动记忆配对蓝牙"
            },{
                icon: require("../../../assets/img/n/icon9.png"),
                title: "整机IPX4防水"
            },{
                icon: require("../../../assets/img/n/icon14.png"),
                title: "通话降噪"
            }]
        }
    },
    methods:{
        switchColor(type){
            this.seletedColor = type;
        }
    }
}
</script>
<style scoped>
.pro_animation .pro_colors i:nth-child(1){
	background-image: url(../../../assets/img/n/pa_2.png);
}

.pro_animation .pro_colors i:nth-child(2){
	background-image: url(../../../assets/img/n/pa_3.png);
	margin-left: 40px;
}
</style>



// WEBPACK FOOTER //
// src/pages/products/N/n5.vue